<div class="text-center my-5">
  <app-spinner message="Cargando"></app-spinner>
</div>
